import axiosInstance from '../mainService';

const areaService = {
    getAreas(search, page, limit, company) {
        // Jika `search` kosong atau null, gunakan string 'all' (atau endpoint khusus untuk semua data)
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m144_areas/name/${sanitizedSearch}/${page}/${limit}/${company}`)
            .then(response => {
                return {
                    data: response.data,
                    headers: response.headers, // Total data dari header
                };
            });
    },    
    totalAllAreas(search, company) {
        // Jika `search` kosong atau null, gunakan string 'all' (atau endpoint khusus untuk semua data)
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m144_areas/name/${sanitizedSearch}/${company}`);
    },
    deleteArea(areaId) {
        return axiosInstance.delete(`/delete-data/m144_areas/${areaId}`);
    },
    addArea(area) {
        return axiosInstance.post('/insert-data/m144_areas', area);
    },
    updateArea(area) {
        return axiosInstance.put(`/update-data/m144_areas/${area.id}`, area);
    }
};

export default areaService;
